// Anything that isn't a plausible id resolves to "" so VideoEmbed renders its
// fallback link instead of an iframe pointing at a malformed src.
const VIMEO_ID = /^\d+$/;
const YOUTUBE_ID = /^[a-zA-Z0-9_-]{8,}$/;

export function extractVimeoId(input: string): string {
  if (VIMEO_ID.test(input)) {
    return input;
  }

  let candidate = "";

  if (input.includes("vimeo.com/")) {
    const remainder = input.split("vimeo.com/")[1] || "";
    candidate = remainder.split(/[/?#]/)[0];
  }

  return VIMEO_ID.test(candidate) ? candidate : "";
}

export function extractYouTubeId(input: string): string {
  if (YOUTUBE_ID.test(input)) {
    return input;
  }

  let candidate = "";

  if (input.includes("youtu.be/")) {
    const remainder = input.split("youtu.be/")[1] || "";
    candidate = remainder.split(/[?&#]/)[0];
  } else if (/[?&]v=/.test(input)) {
    const remainder = input.split(/[?&]v=/)[1] || "";
    candidate = remainder.split(/[&#]/)[0];
  } else {
    // Path-style URLs copied from "Share → Embed" (/embed/ID), Shorts
    // (/shorts/ID), and live links (/live/ID).
    for (const marker of ["/embed/", "/shorts/", "/live/", "/v/"]) {
      if (input.includes(marker)) {
        const remainder = input.split(marker)[1] || "";
        candidate = remainder.split(/[/?&#]/)[0];
        break;
      }
    }
  }

  return YOUTUBE_ID.test(candidate) ? candidate : "";
}

export function getFileNameFromUrl(url: string): string {
  try {
    const { pathname } = new URL(url);
    const segments = pathname.split("/");
    let filename = segments[segments.length - 1] || "File";
    if (!filename) return "File";

    filename = filename.split(/[?#]/)[0];
    return filename || "File";
  } catch {
    return "File";
  }
}
